import Link from "next/link";

export default function NotFound() {
  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        minHeight: "70vh",
        textAlign: "center",
        width: "100%",
        padding: "0 8px",
      }}
    >
      <span className="oi-xs oi-muted">404</span>
      <h1
        className="oi-serif-intro"
        style={{ margin: 0, fontSize: "clamp(2rem, 3vw, 2.5rem)" }}
      >
        This page doesn&apos;t exist.
      </h1>
      <Link href="/" className="oi-btn" style={{ marginTop: 8 }}>
        Go home
      </Link>
    </section>
  );
}
